/**
 * C3  BAR CHART COMPONENT
 *
 * @version  0.1
 */
import React from 'react';
import { isEqual, cloneDeep, merge } from 'lodash';

import C3Chart from './../C3Chart/C3Chart.jsx';

export default class BarChart extends React.Component {

    constructor(props) {
        super(props);

        let config = cloneDeep(this.props.config);
        this.adaptConfigForBarChart(config);

        this.state = {config: config};
    }

    adaptConfigForBarChart(config) {
        config.data = merge({}, config.data, {type: 'bar'});
        config.bar = {
            width: {
                ratio: 0.3
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.config, this.state.config)) {
            let config = cloneDeep(nextProps.config);
            this.adaptConfigForBarChart(config);
            this.setState({config: config});
        }
    }


    render() {
        return (
            <C3Chart config={this.state.config} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Charts/BarChart/BarChart.jsx